import {config} from './module/system/config.js';
import {load} from './module/system/load.js';

//import {basket} from './module/order/basket.js';
//import {user} from './module/users/user.js';

import {thema } from './module/thema/thema.js';

import {bootstrapcss} from '../css/vendor/bootstrap.css';
import {fontcss} from '../css/fonts.css';
import {stylecss} from '../css/style.css';
import {popupcss} from '../css/popup.css';
import {tabscss} from '../css/vendor/tabs.css';
import {preloadercss} from '../css/preloader.css';
import {dadata} from "./module/users/dadata/dadata";


// === Полифил для системной getCookie, если её нет ===
if (typeof window !== 'undefined' && typeof window.getCookie !== 'function') {
	/**
	 * Фолбэк для системной getCookie
	 * @param {string} name   Имя cookie
	 * @param {boolean} asInt Если true — вернуть число, иначе строку
	 * @returns {string|number}
	 */
	window.getCookie = function (name, asInt) {
		// Экранируем спецсимволы в имени cookie
		var escapedName = name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1');
		var pattern = new RegExp('(?:^|; )' + escapedName + '=([^;]*)');
		var matches = document.cookie.match(pattern);
		var value = matches ? decodeURIComponent(matches[1]) : '';

		if (asInt) {
			var num = parseInt(value, 10);
			return isNaN(num) ? 0 : num;
		}

		return value;
	};
}

var mainModule = {
	init: function() {
		String.prototype.firstLetterToUppercase = function() { return this[0].toUpperCase() + this.slice(1); }

		/** мониторинг ошибок на стороне клиента */
		/*
		import("./module/system/errors.js")
			.then(module => module.initErrorReporter({
				endpoint: '/udata/content/save_js_error.json',
				useBeacon: true,
				maxErrors: 100,
				ignoreErrorFunctions: [
					'extractFilteredSchemaValuesFromMicroData',
					'extractSchemaValuesFromSchemaOrg',
					'getCookie'
				]
			}));
		*/

		import("./module/forms/forms-plugin.js")
			.then(m => m.formsPlugin.init({}))
			.catch(console.error);

		// сервис dadata
		mainModule.onElementReady('.selectric-items', function(el) {
			import("./module/users/dadata/dadata.js");
		});


		// кнопка для popup окна
		mainModule.onElementReady('.button-bpopup', function(el) {
			import("./module/forms/bpopup.js");
		});

		// личный кабинет председателя: список пользователей СНТ
		mainModule.onElementReady('.users-of-snt', function() {
			mainModule.loadOnce('users-of-snt', function() {
				return import("./module/users/user-snt.js")
					.then(module => module.userSnt.init());
			});
		});

		/** загрузка одиночного файла */
		/*
		mainModule.onElementReady(".file_upload", () => {
			import("./module/forms/upload-file.js").then( module => module.uploadFile.init() );
		}, { once: false });
		 */

		/** фотогалерея */
		/*
		mainModule.onElementReady("[data-gallery]", () => {
			import("./module/gallery/fancybox.js").then( module => module.imageGallery.init() );
		});
		 */

		/** скролл к элементу */
		if ($(".scroll-link").length) {
			import("./module/tools/scrollTo.js").then( module => module.scrollTo.init() );
		}

		mainModule.onElementReady('.field_phone', function(el) {
			import("./module/forms/inputmask.js")
				.then(({ inputmask }) => {
					inputmask.init(el);
				})
				.catch(function(e) {
					console.error('[mainModule] Ошибка загрузки модуля:', e);
				});
		});

		/** картографический сервис */
		if ($(".map_block").length) {
			import("./module/contact-map.js").then( module => module.yandexMap.init() );
		}

		//import("./module/cookie-alert.js").then( module => module.cookieAlert.init() );
	},

	/**
	 * Запуск функции при появлении элемента(ов) на странице
	 * @param {string} selector
	 * @param {(el: Element) => void} callback
	 * @param {{ once?: boolean }} [opts]
	 */
	onElementReady: function(selector, callback) {
		const processed = new WeakSet();

		/**
		 * Вызвать callback для элемента, если ещё не обрабатывали
		 * @param {Element} el
		 */
		const handleElement = function(el) {
			if (!el || !(el instanceof Element)) return;
			if (processed.has(el)) return;
			processed.add(el);
			callback(el);
		};

		/**
		 * Просканировать корень и найти все элементы по селектору
		 * @param {Element|Document} root
		 */
		const scan = function(root) {
			const ctx = (root && root instanceof Element) ? root : document;
			ctx.querySelectorAll(selector).forEach(handleElement);
		};

		// Инициализация на уже существующей разметке
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', function() {
				scan(document);
			});
		} else {
			scan(document);
		}

		// Наблюдатель за будущими узлами
		const observer = new MutationObserver(function(mutations) {
			mutations.forEach(function(mutation) {
				mutation.addedNodes.forEach(function(node) {
					if (!(node instanceof Element)) return;

					// Сам узел
					if (node.matches && node.matches(selector)) {
						handleElement(node);
					}
					// Его потомки
					scan(node);
				});
			});
		});

		if (document.body) {
			observer.observe(document.body, {
				childList: true,
				subtree: true
			});
		}
	},


	load: function(key) {
	},

	loadOnce: function(key, callback) {
		mainModule.load.cache = mainModule.load.cache || {};

		if (mainModule.load.cache[key]) {
			return mainModule.load.cache[key];
		}

		mainModule.load.cache[key] = callback();
		return mainModule.load.cache[key];
	}
};

try {
	mainModule.init();
} catch (e) {
	console.log(e.name, e.message);
	console.log(e);
}
